import { Heading } from '../../../components/typography/heading/Heading';
import { Text } from '../../../components/typography/text/Text';
import Title from '../../../components/typography/title/Title';
import { Drawer } from '../../molecules/drawer/Drawer';
import SizeGuideTable from '../sizeGuidePage/SizeGuideTable';
import RadioGroupRenderProp from '../sizeGuidePage/utils/RadioGroupRenderProp';
import { useScrollLock } from '../../../utils/useLockScroll';
import styles from './SizeGuide.module.scss';
import PropTypes from 'prop-types';
import React from 'react';
import { useMedia } from 'react-use';

const SizeGuide = React.forwardRef(
  (
    { showDialog, setShowDialog, label, title, description, tableTitle, table },
    ref,
  ) => {
    const isMobile = useMedia('(max-width: 1024px)', false);

    const startModalWidth = isMobile ? 0 : 969;

    useScrollLock(showDialog);

    return (
      <div>
        {showDialog && (
          <Drawer
            onClose={() => {
              setShowDialog(false);
            }}
            shown={showDialog}
            width={startModalWidth}
            position="right"
            customClasses={{
              header: styles.header,
              isMobileDevice: styles.isMobileDevice,
            }}
            type="size-guide"
            className={styles.drawerWrapper}
          >
            <div className={styles.title}>
              <Title>
                <Text as="span" weight="semibold" textTransform="uppercase">
                  {label}
                </Text>
                <Heading as="h2" weight="light" textTransform="uppercase">
                  {title}
                </Heading>
                <Text as="p" weight="light">
                  {description}
                </Text>
              </Title>
            </div>
            <RadioGroupRenderProp styles={styles} sizeGuide={table}>
              {({ radioGroupComponent, newSizeGuide }) => (
                <SizeGuideTable
                  customStyles={styles}
                  tableTitle={tableTitle}
                  table={newSizeGuide}
                  radioGroupComponent={radioGroupComponent}
                  sizeGuide={table}
                  newSizeGuide={newSizeGuide}
                />
              )}
            </RadioGroupRenderProp>
          </Drawer>
        )}
      </div>
    );
  },
);

SizeGuide.propTypes = {
  label: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
};

SizeGuide.defaultProps = {
  label: '',
  title: '',
  description: '',
};

export default SizeGuide;
